<template>
  <div className="flex" aria-label="読み込み中">
    <div className="animate-ping h-1 w-1 bg-gray-600 rounded-full"></div>
    <div className="animate-ping h-1 w-1 bg-gray-600 rounded-full mx-4"></div>
    <div className="animate-ping h-1 w-1 bg-gray-600 rounded-full"></div>
  </div>
</template>